/* ==========================================================================
   RYNOR — TRANSPARENT HEADER OVER THE HERO  (Cold Culture behaviour)
   --------------------------------------------------------------------------
   Runs on the transparent-header pages (home page, /collections, collection pages
   with a hero photo, and both bundle pages) while Theme editor → Header →
   "Transparent header" is ticked. header.liquid then writes data-rynor-overlay="true"
   on the header. The list of pages is in snippets/rynor-overlay-page.liquid.

   What this file does (and nothing else):

     1. Finds the page's hero and checks that it is the first real block under the header:
          home page         the Hero CTA Slider / Hero video (.hero-cta2 / .hero-cta2v)
          bundle pages      the black hero at the top of the bundle builder
          /collections      the dark top of the page, down to where the collection grid starts
          collection pages  the Collection Hero photo
        (anything marked data-rynor-hero counts). If it is, overlay mode stays ON
        (html.rynor-hero-header). If it is not (section moved or removed, something above
        it, or the hero is hidden, like the bundle pages' "extras" step) overlay mode turns
        OFF and your normal solid header is untouched.
        On both collections pages the category row may sit above the hero: header.liquid
        names it in data-rynor-lead and rynor-header-overlay.css restyles it.

     2. Watches the scroll position and toggles  header.section-header.is-solid
          transparent  → while the hero is still behind the header bar
          solid        → as soon as the hero's bottom edge reaches the bottom of the bar
        On the way back up it waits until the hero is HYSTERESIS px behind the bar
        (Cold Culture does the same, so the header never flickers on the boundary).

     3. Keeps two measurements up to date on <html> for rynor-header-overlay.css:
          --rynor-bar-h   the bar's height (content on the other pages starts right under it)
          --rynor-lead-h  the category row's height (on a collection page the hero photo
                          grows by bar + row, so nothing below the photo moves)

   All colours, sizes, gradient and animation timing live in  rynor-header-overlay.css.
   ========================================================================== */
(function () {
  'use strict';

  /* Theme editor re-runs this file when the header section reloads: just refresh. */
  if (window.__rynorHeaderOverlay) {
    window.__rynorHeaderOverlay.refresh(true);
    return;
  }

  /* ---------- Settings you may want to tweak ------------------------------ */
  var CFG = {
    desktopMin: 1026,   // px. Desktop bar from this width up, phone/iPad bar below. Must match the CSS.
    hysteresis: 80      // px. How far the hero must slide back behind the bar before the header turns transparent again.
  };

  var root = document.documentElement;
  var heroEl = null;          // the hero while overlay mode is on (null = overlay off)
  var candidateEl = null;     // the hero found on the page, kept even while it is hidden (bundle "extras" step)
  var candidateShown = false;
  var isSolid = false;
  var ticking = false;
  var resizeObserver = null;
  var barHeight = 0;
  var leadHeight = -1;

  /* ---------- Small helpers ------------------------------------------------ */
  function headerEl() {
    return document.querySelector('header.section-header');
  }

  function activeBar(h) {
    if (!h) return null;
    var wantDesktop = window.innerWidth >= CFG.desktopMin;
    return h.querySelector(wantDesktop ? '.section-header__main-bar' : '.section-header__mobile');
  }

  /* On screen at all? False for display:none and for anything inside a hidden step. */
  function isShown(el) {
    return !!el && el.getClientRects().length > 0;
  }

  /* Height of whichever bar is showing (desktop or phone/iPad) → --rynor-bar-h on <html> */
  function publishBarHeight() {
    var h = headerEl();
    if (!h) return;
    var bars = h.querySelectorAll('.section-header__main-bar, .section-header__mobile');
    var px = 0;
    for (var i = 0; i < bars.length; i++) px = Math.max(px, bars[i].offsetHeight);
    if (px && px !== barHeight) {
      barHeight = px;
      root.style.setProperty('--rynor-bar-h', px + 'px');
    }
  }

  /* Height of the rows allowed above the hero (the category row) → --rynor-lead-h on <html> */
  function publishLeadHeight(hero) {
    var h = headerEl();
    var wrap = document.querySelector('.page-wrap');
    var lead = h ? (h.getAttribute('data-rynor-lead') || '') : '';
    var px = 0;
    if (lead && hero && wrap) {
      var els = [];
      try { els = wrap.querySelectorAll(lead); } catch (e) { els = []; }
      for (var i = 0; i < els.length; i++) {
        /* 4 = DOCUMENT_POSITION_FOLLOWING: only rows that come before the hero count */
        if (els[i].compareDocumentPosition(hero) & 4) px += els[i].offsetHeight;
      }
    }
    if (px !== leadHeight) {
      leadHeight = px;
      root.style.setProperty('--rynor-lead-h', px + 'px');
    }
  }

  var HERO_SELECTOR = '.hero-cta2, .hero-cta2v, [data-rynor-hero]';

  /* A section that may sit above the hero on this page (the category row) */
  function isLead(section, leadSelector) {
    if (!leadSelector) return false;
    try { return !!section.querySelector(leadSelector); } catch (e) { return false; }
  }

  /* Walk the sections of the page top-down.
       - empty wrappers (height 0) are skipped
       - sections named in the header's data-rynor-lead are skipped
       - the first real section decides: hero → overlay ON, anything else → OFF */
  function findHero() {
    var wrap = document.querySelector('.page-wrap');
    var h = headerEl();
    /* data-rynor-overlay is written by header.liquid: "true" on a transparent-header page while the switch is ticked */
    if (!wrap || !h || h.getAttribute('data-rynor-overlay') !== 'true') return null;
    var lead = h.getAttribute('data-rynor-lead') || '';

    var kids = wrap.children;
    for (var i = 0; i < kids.length; i++) {
      var s = kids[i];
      if (!s.classList || !s.classList.contains('shopify-section')) continue;

      var hero = s.querySelector(HERO_SELECTOR);
      if (hero) return hero;
      if (s.offsetHeight === 0) continue;   // empty wrapper, e.g. a section that renders nothing
      if (isLead(s, lead)) continue;        // allowed above the hero on this page
      return null;                          // a real section that is not the hero → no overlay
    }
    return null;
  }

  function setOverlay(on) {
    root.classList.toggle('rynor-hero-header', !!on);
    if (!on) {
      var h = headerEl();
      if (h) h.classList.remove('is-solid');
      isSolid = false;
    }
  }

  /* ---------- The scroll logic --------------------------------------------- */
  function update() {
    ticking = false;

    /* The hero was hidden or shown again (bundle pages: build step ↔ extras step) → switch overlay mode */
    if (candidateEl && isShown(candidateEl) !== candidateShown) { refresh(true); return; }
    if (!heroEl || !root.classList.contains('rynor-hero-header')) return;

    var h = headerEl();
    var bar = activeBar(h);
    if (!h || !bar) return;

    var barH = bar.offsetHeight || 40;
    var heroBottom = heroEl.getBoundingClientRect().bottom;

    /* going down: solid when the hero's bottom edge reaches the bar's bottom edge
       going up:   transparent only after the hero is `hysteresis` px behind the bar */
    isSolid = isSolid ? (heroBottom <= barH + CFG.hysteresis) : (heroBottom <= barH);
    h.classList.toggle('is-solid', isSolid);
  }

  function schedule() {
    if (ticking || !candidateEl) return;   // nothing to do on pages without the transparent header
    ticking = true;
    window.requestAnimationFrame(update);
  }

  /* No animation on the very first paint (e.g. page reloaded halfway down the page). */
  function paintInstantly() {
    var h = headerEl();
    if (!h) return;
    h.classList.add('rynor-header--instant');
    update();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var hh = headerEl();
        if (hh) hh.classList.remove('rynor-header--instant');
      });
    });
  }

  /* Follows the hero's size, and notices when it is hidden or shown again (checked in update). */
  function watchHero() {
    if (resizeObserver) { resizeObserver.disconnect(); resizeObserver = null; }
    if (candidateEl && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(candidateEl);
    }
  }

  /* ---------- (Re)initialise ----------------------------------------------- */
  function refresh(instant) {
    candidateEl = findHero();
    candidateShown = isShown(candidateEl);
    heroEl = candidateShown ? candidateEl : null;
    setOverlay(!!heroEl);
    publishBarHeight();
    publishLeadHeight(candidateEl);
    watchHero();

    if (!heroEl) return;
    if (instant) paintInstantly(); else update();
  }

  function init() {
    refresh(true);

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () { refresh(false); }, { passive: true });
    window.addEventListener('orientationchange', function () { refresh(false); });
    window.addEventListener('load', function () { refresh(false); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(true); });

    /* Shopify theme editor: sections get re-rendered / moved while you edit */
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect']
      .forEach(function (name) {
        document.addEventListener(name, function () {
          window.setTimeout(function () { refresh(true); }, 60);
        });
      });
  }

  window.__rynorHeaderOverlay = { refresh: refresh, update: update, config: CFG };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
